const Presets = {
  modalInfo : {
      open: true,
      forceRender: true,
      closable: true,
      closeOnOutsideClick: true,
      footer: null,
      closeIcon: null,
  }
}

export default Presets